import { HttpClient, HttpMethods } from "../types/httpClient";

function getResourcesTags(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<{ tags: string[] }>({
        endpoint: "/resources/tags",
        method: HttpMethods.GET,
      })
      .then(({ tags }) => tags.map((name) => ({ name })));
}

export { getResourcesTags };
